import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const image191100MmaLandscapeRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.91,
  type: 'Image191x100',
  associationType: 'LandscapeImageMedia',
  imagePreviewHeight: 244,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [703, 368],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Landscape Image Multimedia Ad'),
    stringKey: _TL_('1.91 : 1'),
  },
  previewSettings: {
    showAdsLabel: true,
    showImage: true,
    showDescription: true,
    showShortHeadline: true,
    showAdditionalDisclaimer: true,
    showAction: true,
    showUrl: true,
  },
  styleOverrides: {
    adsLabel: {
      backgroundColor: 'white',
    },
    description: {
      color: 'black',
      maxWidth: 250,
      wordWrap: 'break-word',
      paddingRight: 16,
      fontSize: 14,
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
      borderRadius: 0,
      boxShadow: 'none',
    },
    shortHeadline: {
      fontSize: 24,
      fontWeight: 200,
      marginBottom: 8,
      paddingBottom: 5,
      color: 'black',
    },
    textContainer: {
      padding: '8px 20px 20px 20px',
      maxWidth: '-webkit-fill-available',
      width: 466,
      lineHeight: 1.1,
    },
    finalUrl: {
      color: 'green',
      fontSize: 10,
      marginBottom: 8,
    },
    actionButton: {
      right: 15,
      bottom: 15,
      padding: '6px 16px 8px 16px',
      fontSize: 16,
      fontWeight: 'bold',
      borderRadius: 32,
    },
  },
};

export default image191100MmaLandscapeRaw;
